export function SectionHeader({ kicker, title, description, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {kicker && (
        <div className="flex items-center gap-3 mb-5">
          <span className="w-8 h-[2px] bg-[#FF4F00]" />
          <span className="label-mono text-[#FF4F00]">{kicker}</span>
        </div>
      )}
      <h2 className="font-display text-3xl sm:text-5xl uppercase tracking-tight leading-[0.95]">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-base sm:text-lg text-neutral-700 leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
}

export function Container({ children, className = "" }) {
  return (
    <div className={`max-w-[1500px] mx-auto px-5 sm:px-8 ${className}`}>
      {children}
    </div>
  );
}

export function CodeTag({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] uppercase px-2 py-1 brut-border bg-[#F0F0EC] ${className}`}>
      <span className="w-1.5 h-1.5 bg-[#FF4F00]" />
      {children}
    </span>
  );
}
